import React, { Component } from "react";
import { connect } from "react-redux";
import SortIcon from "components/sort-icon";

const TYPE_TWDTD = "twdtd";
const TYPE_TWDTJ = "twdtj";
const TYPE_TWDTB_SPIDER = "twdtb-spider";
const TYPE_TWDTB_TERR = "twdtb-terr";
const TYPE_TWDTB_SHARK = "twdtb-shark";

const SORT_FIELD_NAME = "name";
const SORT_FIELD_TEAM = "team";
const SORT_FIELD_TWDTD_RATING = "twdtd-rating";
const SORT_FIELD_TWDTJ_RATING = "twdtj-rating";
const SORT_FIELD_TWDTB_RATING = "twdtb-rating";
const SORT_FIELD_TOTAL_RATING = "total-rating";
const SORT_FIELD_GAMES_PLAYED = "games-played";
const SORT_FIELD_GAMES_WON = "games-won";
const SORT_FIELD_KILLS = "kills";
const SORT_FIELD_DEATHS = "deaths";
const SORT_FIELD_KILLS_PER_DEATH = "kills-per-death";
const SORT_FIELD_KILLS_PER_MINUTE = "kills-per-minute";
const SORT_FIELD_TERR_KILLS = "terr-kills";
const SORT_FIELD_REPS_PER_DEATH = "reps-per-death";
const SORT_FIELD_RATING = "rating";
const SORT_DIRECTION_ASCENDING = "ascending";
const SORT_DIRECTION_DESCENDING = "descending";

const DEFAULT_ROW_HEADINGS = {
  rank: true,
  name: true,
  team: true,
  gameType: true,
  // twdtdRating: true,
  // twdtjRating: true,
  // twdtbRating: true,
  // totalRating: true,
  stars: true,
  gamesPlayed: true,
  gamesWon: true,
  kills: true,
  deaths: true,
  kpd: true,
  kpm: true,
};

class PlayersTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortField: SORT_FIELD_RATING,
      sortDirection: SORT_DIRECTION_DESCENDING,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.setState({
        sortField: SORT_FIELD_RATING,
        sortDirection: SORT_DIRECTION_DESCENDING,
      });
    }
  }

  sortableHeadingClicked = (field) => {
    const { sortField, sortDirection } = this.state;
    let _sortDirection;

    if (sortField !== field) {
      // just use the existing direction if they are changing fields
      _sortDirection = sortDirection;
    } else {
      // and if its the same field, just toggle direction
      _sortDirection =
        sortDirection === SORT_DIRECTION_ASCENDING
          ? SORT_DIRECTION_DESCENDING
          : SORT_DIRECTION_ASCENDING;
    }

    this.setState({
      sortField: field,
      sortDirection: _sortDirection,
    });
  };

  render() {
    const { type, players } = this.props;
    const { sortField, sortDirection } = this.state;

    let sortedPlayers = [];

    if (sortField === SORT_FIELD_NAME) {
      sortedPlayers = players.sort((a, b) => {
        if (sortDirection === SORT_DIRECTION_ASCENDING) {
          if (a.fcName < b.fcName) return -1;
          if (a.fcName > b.fcName) return 1;
        } else {
          if (b.fcName < a.fcName) return -1;
          if (b.fcName > a.fcName) return 1;
        }
        return 0;
      });
    } else if (sortField === SORT_FIELD_TEAM) {
      sortedPlayers = players.sort((a, b) => {
        if (sortDirection === SORT_DIRECTION_ASCENDING) {
          if (a.fcTeamName < b.fcTeamName) return -1;
          if (a.fcTeamName > b.fcTeamName) return 1;
        } else {
          if (b.fcTeamName < a.fcTeamName) return -1;
          if (b.fcTeamName > a.fcTeamName) return 1;
        }
        return 0;
      });
    } else if (sortField === SORT_FIELD_TWDTD_RATING) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.fnWBStars - b.fnWBStars
          : b.fnWBStars - a.fnWBStars;
      });
    } else if (sortField === SORT_FIELD_TWDTJ_RATING) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.fnJavStars - b.fnJavStars
          : b.fnJavStars - a.fnJavStars;
      });
    } else if (sortField === SORT_FIELD_TWDTB_RATING) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.fnBaseStars - b.fnBaseStars
          : b.fnBaseStars - a.fnBaseStars;
      });
    } else if (sortField === SORT_FIELD_TOTAL_RATING) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.fnStars - b.fnStars
          : b.fnStars - a.fnStars;
      });
    } else if (sortField === SORT_FIELD_GAMES_PLAYED) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.roundsPlayed - b.stats.roundsPlayed ||
              a.stats.rating - b.stats.rating
          : b.stats.roundsPlayed - a.stats.roundsPlayed ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_GAMES_WON) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.roundsWon - b.stats.roundsWon ||
              a.stats.rating - b.stats.rating
          : b.stats.roundsWon - a.stats.roundsWon ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KILLS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.kills - b.stats.kills || a.stats.rating - b.stats.rating
          : b.stats.kills - a.stats.kills || b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_DEATHS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.fnDeaths - b.stats.fnDeaths ||
              a.stats.rating - b.stats.rating
          : b.stats.fnDeaths - a.stats.fnDeaths ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KILLS_PER_DEATH) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.killsPerDeath - b.stats.killsPerDeath ||
              a.stats.rating - b.stats.rating
          : b.stats.killsPerDeath - a.stats.killsPerDeath ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KILLS_PER_MINUTE) {
      sortedPlayers = players.sort((a, b) => {
        const a_kpm = Math.round((a.stats.killsPer30Min / 30) * 100) / 100;
        const b_kpm = Math.round((b.stats.killsPer30Min / 30) * 100) / 100;

        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a_kpm - b_kpm || a.stats.rating - b.stats.rating
          : b_kpm - a_kpm || b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_RATING) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.rating - b.stats.rating || a.stats.kills - b.stats.kills
          : b.stats.rating - a.stats.rating || b.stats.kills - a.stats.kills;
      });
    } else if (sortField === SORT_FIELD_TERR_KILLS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.fnTerrierKill - b.stats.fnTerrierKill ||
              a.stats.rating - b.stats.rating
          : b.stats.fnTerrierKill - a.stats.fnTerrierKill ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_REPS_PER_DEATH) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.repsPerDeath - b.stats.repsPerDeath ||
              a.stats.rating - b.stats.rating
          : b.stats.repsPerDeath - a.stats.repsPerDeath ||
              b.stats.rating - a.stats.rating;
      });
    }

    return (
      <div className="players-table">
        <table>
          <thead>
            {(type === TYPE_TWDTD || type === TYPE_TWDTJ) && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType={type}
                rating
                kpm
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
            {(type === TYPE_TWDTB_SPIDER || type === TYPE_TWDTB_TERR) && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType="twdtb"
                terrKills
                rating
                kpm
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
            {type === TYPE_TWDTB_SHARK && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType="twdtb"
                terrKills
                repsPerDeath
                rating
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
          </thead>
          <tbody>
            {sortedPlayers.map((player, i) => {
              let kpm = 0;
              if (player.stats.killsPer30Min) {
                kpm = Math.round((player.stats.killsPer30Min / 30) * 100) / 100;
              }

              if (player.fcTeamName === "")
                player.fcTeamName = "-";

              if (type === TYPE_TWDTD || type === TYPE_TWDTJ) {
                return (
                  <PlayerRow
                    gameType={type}
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    stars={
                      type === TYPE_TWDTD ? player.fnWBStars : player.fnJavStars
                    }
                    twdtdRating={player.fnWBStars}
                    twdtjRating={player.fnJavStars}
                    twdtbRating={player.fnBaseStars}
                    totalRating={player.fnStars}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpm={kpm.toString()}
                    rating={player.stats.gameScoreNew.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } else if (
                type === TYPE_TWDTB_SPIDER ||
                type === TYPE_TWDTB_TERR
              ) {
                return (
                  <PlayerRow
                    gameType="twdtb"
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    stars={player.fnBaseStars}
                    twdtdRating={player.fnWBStars}
                    twdtjRating={player.fnJavStars}
                    twdtbRating={player.fnBaseStars}
                    totalRating={player.fnStars}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpm={kpm.toString()}
                    terrKills={player.stats.fnTerrierKill.toString()}
                    rating={player.stats.rating.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } else if (type === TYPE_TWDTB_SHARK) {
                return (
                  <PlayerRow
                    gameType="twdtb"
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    stars={player.fnBaseStars}
                    twdtdRating={player.fnWBStars}
                    twdtjRating={player.fnJavStars}
                    twdtbRating={player.fnBaseStars}
                    totalRating={player.fnStars}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpm={kpm.toString()}
                    terrKills={player.stats.fnTerrierKill.toString()}
                    repsPerDeath={player.stats.repsPerDeath.toString()}
                    rating={player.stats.rating.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } else {
                return null;
              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

const PlayerHeader = ({
  gameType,
  rank,
  name,
  team,
  twdtdRating,
  twdtjRating,
  twdtbRating,
  totalRating,
  gamesPlayed,
  kills,
  deaths,
  terrKills,
  repsPerDeath,
  rating,
  sortField,
  sortDirection,
  sortFn,
  gamesWon,
  kpd,
  kpm,
  stars,
}) => (
  <tr>
    {rank &&
    sortField === SORT_FIELD_RATING &&
    sortDirection === SORT_DIRECTION_DESCENDING ? (
      <th className="players-table--header--rank" nowrap="true">
        <div className="players-table--header--link">
          <span>#</span>
        </div>
      </th>
    ) : null}
    {name ? (
      <th className="players-table--header--name" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_NAME);
          }}
        >
          <span>Name</span>
          {sortField === SORT_FIELD_NAME ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {team ? (
      <th className="players-table--header--team" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TEAM);
          }}
        >
          <span>Team</span>
          {sortField === SORT_FIELD_TEAM ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {stars ? (
      <th className={`players-table--header--rating ${gameType}`} nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(`${gameType}-rating`);
          }}
        >
          <span>
            <i className="fas fa-star" />
          </span>
          {sortField === `${gameType}-rating` ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {twdtdRating ? (
      <th className="players-table--header--rating twdtd" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TWDTD_RATING);
          }}
        >
          <span>
            <i className="fas fa-star" />
          </span>
          {sortField === SORT_FIELD_TWDTD_RATING ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {twdtjRating ? (
      <th className="players-table--header--rating twdtj" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TWDTJ_RATING);
          }}
        >
          <span>
            <i className="fas fa-star" />
          </span>
          {sortField === SORT_FIELD_TWDTJ_RATING ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {twdtbRating ? (
      <th className="players-table--header--rating twdtb" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TWDTB_RATING);
          }}
        >
          <span>
            <i className="fas fa-star" />
          </span>
          {sortField === SORT_FIELD_TWDTB_RATING ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {totalRating ? (
      <th className="players-table--header--rating total" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TOTAL_RATING);
          }}
        >
          <span>
            <i className="fas fa-star" />
          </span>
          {sortField === SORT_FIELD_TOTAL_RATING ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {gamesPlayed ? (
      <th className="players-table--header--stat games-played" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_GAMES_PLAYED);
          }}
        >
          <span>GP</span>
          {sortField === SORT_FIELD_GAMES_PLAYED ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {gamesWon ? (
      <th className="players-table--header--stat games-won" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_GAMES_WON);
          }}
        >
          <span>Wins</span>
          {sortField === SORT_FIELD_GAMES_WON ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {kills ? (
      <th className="players-table--header--stat kills" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KILLS);
          }}
        >
          <span>K</span>
          {sortField === SORT_FIELD_KILLS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {deaths ? (
      <th className="players-table--header--stat deaths" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_DEATHS);
          }}
        >
          <span>D</span>
          {sortField === SORT_FIELD_DEATHS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {kpd ? (
      <th className="players-table--header--stat kpd" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KILLS_PER_DEATH);
          }}
        >
          <span>KPD</span>
          {sortField === SORT_FIELD_KILLS_PER_DEATH ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {kpm ? (
      <th className="players-table--header--stat kpm" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KILLS_PER_MINUTE);
          }}
        >
          <span>KPM</span>
          {sortField === SORT_FIELD_KILLS_PER_MINUTE ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {terrKills ? (
      <th className="players-table--header--stat terr-kills" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TERR_KILLS);
          }}
        >
          <span>TeKs</span>
          {sortField === SORT_FIELD_TERR_KILLS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {repsPerDeath ? (
      <th className="players-table--header--stat reps-per-death" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_REPS_PER_DEATH);
          }}
        >
          <span>RPD</span>
          {sortField === SORT_FIELD_REPS_PER_DEATH ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {rating ? (
      <th className="players-table--header--stat rating" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_RATING);
          }}
        >
          <span>Rating</span>
          {sortField === SORT_FIELD_RATING ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
  </tr>
);

const PlayerRow = ({
  stars,
  gameType,
  rank,
  name,
  team,
  twdtdRating,
  twdtjRating,
  twdtbRating,
  totalRating,
  gamesPlayed,
  kills,
  deaths,
  terrKills,
  repsPerDeath,
  rating,
  sortField,
  sortDirection,
  gamesWon,
  kpd,
  kpm,
}) => (
  <tr className="players-table--row">
    {rank &&
    sortField === SORT_FIELD_RATING &&
    sortDirection === SORT_DIRECTION_DESCENDING ? (
      <td className="players-table--row--rank" nowrap="true">
        {rank}
      </td>
    ) : null}
    {name ? (
      <td className="players-table--row--name" nowrap="true">
        {name}
      </td>
    ) : null}
    {team ? (
      <td className="players-table--row--team" nowrap="true">
        {team}
      </td>
    ) : null}
    {stars ? (
      <td
        className={`players-table--row--rating ${gameType}`}
        nowrap="true"
        title={`${twdtdRating / 10}/${twdtjRating / 10}/${twdtbRating / 10}/${
          totalRating / 10
        }`}
      >
        {stars / 10}
      </td>
    ) : null}
    {/*{twdtdRating ? <td className="players-table--row--rating twdtd" nowrap="true">{twdtdRating}</td> : null}*/}
    {/*{twdtjRating ? <td className="players-table--row--rating twdtj" nowrap="true">{twdtjRating}</td> : null}*/}
    {/*{twdtbRating ? <td className="players-table--row--rating twdtb" nowrap="true">{twdtbRating}</td> : null}*/}
    {/*{totalRating ? <td className="players-table--row--rating total" nowrap="true">{totalRating}</td> : null}*/}
    {gamesPlayed ? (
      <td className="players-table--row--stat games-played" nowrap="true">
        {gamesPlayed}
      </td>
    ) : null}
    {gamesWon ? (
      <td className="players-table--row--stat games-won" nowrap="true">
        {gamesWon}
      </td>
    ) : null}
    {kills ? (
      <td className="players-table--row--stat kills" nowrap="true">
        {kills}
      </td>
    ) : null}
    {deaths ? (
      <td className="players-table--row--stat deaths" nowrap="true">
        {deaths}
      </td>
    ) : null}
    {kpd ? (
      <td className="players-table--row--stat kpd" nowrap="true">
        {kpd}
      </td>
    ) : null}
    {kpm ? (
      <td className="players-table--row--stat kpm" nowrap="true">
        {kpm}
      </td>
    ) : null}
    {terrKills ? (
      <td className="players-table--row--stat terr-kills" nowrap="true">
        {terrKills}
      </td>
    ) : null}
    {repsPerDeath ? (
      <td className="players-table--row--stat reps-per-death" nowrap="true">
        {repsPerDeath}
      </td>
    ) : null}
    {rating ? (
      <td className="players-table--row--stat rating" nowrap="true">
        {rating}
      </td>
    ) : null}
  </tr>
);

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(PlayersTable);



// WEBPACK FOOTER //
// ./src/components/players-table/players-table.js